const API_BASE_URL = process.env.REACT_APP_BASE_API_URL

export const editAffiliate = async (id, affiliateData) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API_BASE_URL}/admin/user/affiliator-accounts/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(affiliateData),
      });
  
      const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    return data;
  } catch (error) {
    console.error('Ошибка:', error);
    throw error;
  }
  };